import skeletonAsset from "./assets/skeletonAsset";

const Skeleton = (ratio: string, imagePath: string) => {
  const m_ratio = `${ratio.replace(":", "_").replace(".", "_")}`;
  const skeletonAssetKey = Object.keys(skeletonAsset);

  if (skeletonAssetKey.includes(m_ratio)) {
    return skeletonAsset[m_ratio];
  }
  return imagePath;
};

export default Skeleton;
